export default "__VITE_ASSET__CP6NAGa1__"